import React, { useState } from 'react';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CardContent,
  Card,
  IconButton,
} from '@material-ui/core';
import { Add, Remove, OpenWith } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setItsMaterialDialog, setData } from '../../../redux';
import { sortByDate } from '../../../../helperFunctions';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);

  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const endTaskDialogTaskId = useSelector(state => state.tasks.endTaskDialog.taskId);
  const taskStarted = useSelector(state => state.tasks.taskStarted);
  const materialsDialog = useSelector(state => state.tasks.materialsDialog);
  const data = useSelector(state => state.tasks.data);
  const task = data.tasks.find(
    x => x.id === showTaskDetails.taskId || x.id === endTaskDialogTaskId
  );

  const itsUninstaledMaterials = task.itsUninstaledMaterials;

  const fontSize = width <= 500 ? '4vw' : '20px';

  const removeItsUninstaledMaterial = (material, itsUninstaledMaterials, data, dispatch) => {
    let updatedItsUninstaledMaterials = [...itsUninstaledMaterials];

    updatedItsUninstaledMaterials = updatedItsUninstaledMaterials.filter(
      m => m.materialSerialNumber !== material.materialSerialNumber
    );

    const tasks = [...data.tasks];
    const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
    tasks.splice(taskIndex, 1, {
      ...task,
      itsUninstaledMaterials: updatedItsUninstaledMaterials,
    });

    dispatch(
      setData({
        ...data,
        tasks: tasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  return task ? (
    <Card style={{ marginTop: '3px' }}>
      <div style={{ backgroundColor: task.ticketId ? '#da291c' : '#a5daff', padding: '3px' }}>
        <Typography
          gutterBottom
          component="span"
          style={{
            fontSize,
            color: task.ticketId ? 'white' : 'black',
            padding: '1px',
            marginRight: '4px',
          }}
        >
          ITS Деинсталирани Материали
          {open ? (
            <Chip
              style={{ fontSize, margin: '2px' }}
              avatar={<Remove />}
              onClick={() => setOpen(false)}
              clickable
            />
          ) : (
            <Chip
              style={{ fontSize, margin: '2px' }}
              avatar={<OpenWith />}
              onClick={() => setOpen(true)}
              clickable
            />
          )}
        </Typography>
        {taskStarted.started &&
          taskStarted.taskId === task.id &&
          !materialsDialog.open &&
          !task.appEnd && (
            <Chip
              style={{ margin: '1px', fontSize }}
              avatar={<Add />}
              onClick={() =>
                dispatch(
                  setItsMaterialDialog({
                    open: true,
                    dataSet: 'itsMaterials',
                    checkout: true,
                    isInstaledMaterials: false,
                    task: task,
                  })
                )
              }
              clickable
              label="Добави"
            />
          )}
        {task.appEnd && !materialsDialog.open && (
          <Chip
            style={{ margin: '1px', fontSize }}
            avatar={<Add />}
            onClick={() =>
              dispatch(
                setItsMaterialDialog({
                  open: true,
                  dataSet: 'itsMaterials',
                  checkout: true,
                  isInstaledMaterials: false,
                  task: task,
                })
              )
            }
            clickable
            label="Добави при вече затворена задача"
          />
        )}
      </div>
      {open && (
        <CardContent>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontSize }} size="small">
                  Име
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Сер. номер
                </TableCell>
                <TableCell style={{ fontSize }} size="small">
                  Състояние
                </TableCell>
                <TableCell style={{ fontSize }} size="small" />
              </TableRow>
            </TableHead>
            <TableBody>
              {itsUninstaledMaterials &&
                itsUninstaledMaterials
                  .filter(x => x.taskId === task.id)
                  .map(x => (
                    <TableRow key={x.materialSerialNumber}>
                      <TableCell style={{ fontSize }} size="small">
                        {x.materialTypeName}
                      </TableCell>
                      <TableCell style={{ fontSize }} size="small">
                        {x.materialSerialNumber}
                      </TableCell>
                      <TableCell style={{ fontSize }} size="small">
                        {x.materialCondition}
                      </TableCell>
                      <TableCell style={{ fontSize }} size="small">
                        <IconButton
                          onClick={() =>
                            removeItsUninstaledMaterial(x, itsUninstaledMaterials, data, dispatch)
                          }
                        >
                          <Remove />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </CardContent>
      )}
    </Card>
  ) : null;
};
